import React from 'react'
import EditarCereal from './EditarCereal'
import EliminarCereal from './EliminarCereal'

function OperacionesCereales (props) {
  const { data } = props
  return (
    <div style={{ display: 'flex' }}>
      <EditarCereal data={data} />
      <EliminarCereal data={data} />
    </div>
  )
}

export default OperacionesCereales
